import React,{ useState, useEffect,useMemo } from 'react'
import "./AssignPermission.css"
import { useDispatch } from "react-redux";
import { updateRoleById ,getRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import mainLogo from "./../../../../assets/global_assets/assignPermission/mainLogo.png"
import section_header_icon from "./../../../../assets/global_assets/assignPermission/section_header_icon.png"
import create_header_icon from "./../../../../assets/global_assets/assignPermission/create_header_icon.png"
import edit_header_icon from "./../../../../assets/global_assets/assignPermission/edit_header_icon.png"
import delete_header_icon from "./../../../../assets/global_assets/assignPermission/delete_header_icon.png"
import { IoIosArrowForward , IoIosArrowDown } from "react-icons/io";

function AssignPermission({ showSnackbar, setLoading }) {
    const dispatch = useDispatch();
    const [roleData, setRoleData] = useState([])
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
    const currentUserBaseRole = use_company_code.base_role;
    const currentUserRole = use_company_code.role_name;
    const [checkedRoleName ,setCheckedRoleName] = useState('');
    const [persedData , setpersedData] = useState([])
    const [permissionAccess , setPermissionAccess] = useState([])
    const [permissionAccessed , setPermissionAccessed] = useState([])
    const [expandedSections, setExpandedSections] = useState({});
    const [checkedItems, setCheckedItems] = useState({});
    const [activeTab, setActiveTab] = useState(null);
    const [btnDataTag, setBtnDataTag] = useState("Submit");

    
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "Registers";
      setActiveTab(savedTab);
    }, []);
  const toggleSection = (sectionKey) => {
    setExpandedSections((prev) => ({
      [sectionKey]: !prev[sectionKey],
    }));
  };
  const isActionEnabled = (action, actionType) => {
    if (action === 'Yes') return true;
    if (typeof action === 'object') return action[actionType] === true;
    return false;
  };
  const hasAnySubAction = (subModules = [], actionType) => {
    return subModules.some((sub) =>
      isActionEnabled(sub.action, actionType)
    );
  };
  const hasAnySectionAction = (modules = [], actionType) => {
    return modules.some((perm) =>
      hasAnyModuleAction(perm, actionType)
    );
  };
  
  const hasAnyModuleAction = (perm, actionType) => {

    if (perm.sub_module?.length > 0) {
      return perm.sub_module.some((sub) =>
        isActionEnabled(sub.action, actionType)
      );
    }
  
    if (perm.action) {
      return isActionEnabled(perm.action, actionType);
    }
  
    return false;
  };
  
  const groupedBySection = useMemo(() => {
    return permissionAccess.reduce((acc, perm) => {
      const section =
        perm.section === "Generated Forms" ? "Generated Form" : perm.section;
      const normalizedPerm = {
        ...perm,
        section,
        module:
          perm.module === "Generated Forms" ? "Generated Form" : perm.module,
        sub_module: Array.isArray(perm.sub_module) ? perm.sub_module : [],
      };
      if (!acc[section]) acc[section] = [];
      acc[section].push(normalizedPerm);
      return acc;
    }, {});
  }, [permissionAccess]);
  
  const handleFetchRoleData = async () => {
    try {
      const response = await dispatch(getRole());
      let filteredRoles = response.data;

      if (currentUserBaseRole === "SuperAdmin") {
        filteredRoles = response.data.filter((data) => data.base_role !== "SuperAdmin" && data.base_role !== "vendor");
      } else if (currentUserBaseRole === "Admin") {
        filteredRoles = response.data.filter(
          (data) => data.base_role !== "SuperAdmin" && data.base_role !== "Admin" && data.base_role !== "vendor"
        );
      } else if (currentUserBaseRole === "Processor") {
        filteredRoles = response.data.filter((data) => data.base_role === "Client");
      } else {
        filteredRoles = [];
      }

      setRoleData(filteredRoles);

      let rawPermissions = response.data.find((data) => data.role_name === currentUserRole)?.permissions;
      if(!Array.isArray(rawPermissions)){
        rawPermissions = JSON.parse(rawPermissions);
      }
      let parsed = [];
      if (Array.isArray(rawPermissions)) {
          if (typeof rawPermissions[0] === "string") {
              try {
              parsed = JSON.parse(rawPermissions[0]);
              } catch (e) {
              console.error("Failed to parse inner permission JSON:", e);
              }
          } else {
              parsed = rawPermissions;
          }
          } else if (typeof rawPermissions === "string") {
          try {
              parsed = JSON.parse(rawPermissions);
          } catch (e) {
              console.error("Failed to parse rawPermissions:", e);
          }
      }
        setpersedData(parsed);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
        if (sessionStorage.getItem('activeTab') == "Audit") {
          setPermissionAccess(persedData.filter(item => item.service != "Registers"));
        } else {
          setPermissionAccess(persedData.filter(item => item.service != "Audit"));
        }
  }, [persedData]);
  
  useEffect(() => {
    handleFetchRoleData();
  }, [dispatch]);  
  useEffect(() => {

    if (Object.keys(groupedBySection).length > 0) {
      const firstSectionKey = `section-${Object.keys(groupedBySection)[0]}`;
      
      setExpandedSections((prev) => {
        if (Object.keys(prev).length === 0) {
          return { [firstSectionKey]: true };
        }
        return prev;
      });
    }
  }, [groupedBySection]);
  
  
  const getSectionCrudActions = (section) => {
    const crudStatus = { create: false, edit: false, delete: false };
    
    groupedBySection[section].forEach(perm => {
      if (perm.action === 'Yes') {
        crudStatus.create = crudStatus.edit = crudStatus.delete = true;
      } else if (typeof perm.action === 'object') {
        Object.keys(perm.action).forEach(key => {
          if (perm.action[key] === true) {
            crudStatus[key] = true;
          }
        });
      }
      
      if (perm.sub_module) {
        perm.sub_module.forEach(sub => {
          if (sub.action && typeof sub.action === 'object') {
            Object.keys(sub.action).forEach(key => {
              if (sub.action[key] === true) {
                crudStatus[key] = true;
              }
            });
          }
        });
      }
    });
    return crudStatus;
  };
  const enforceCheckboxRules = (state) => {
    const newState = { ...state };
  
    Object.keys(groupedBySection).forEach(section => {
      const sectionKey = `section-${section}`;
      const isSectionChecked = newState[sectionKey] || false;
  
      groupedBySection[section].forEach((perm, permIdx) => {
        const moduleKey = `module-${section}-${permIdx}`;
        const isModuleChecked = newState[moduleKey] || false;
  
        ['create', 'edit', 'delete'].forEach(crudType => {
          const sectionCrudKey = `section-crud-${section}-${crudType}`;
          const moduleCrudKey = `module-crud-${section}-${permIdx}-${crudType}`;
  
          if (!isModuleChecked) {
            newState[moduleCrudKey] = false;
          }
  
          // At the same time, reset section CRUD if section is unchecked
          if (!isSectionChecked) {
            newState[sectionCrudKey] = false;
          }
        });
  
        if (perm.sub_module) {
          perm.sub_module.forEach((sub, subIdx) => {
            const submoduleKey = `submodule-${section}-${permIdx}-${subIdx}`;
            const isSubChecked = newState[submoduleKey] || false;
  
            // Reset submodule CRUDs if submodule is unchecked
            ['create', 'edit', 'delete'].forEach(crudType => {
              const subCrudKey = `submodule-${section}-${permIdx}-${subIdx}-${crudType}`;
              if (!isSubChecked) {
                newState[subCrudKey] = false;
              }
            });
  
            // Sync module checkbox: if any submodule is unchecked → module unchecked
            const allSubChecked = perm.sub_module.every((_, sIdx) =>
              !!newState[`submodule-${section}-${permIdx}-${sIdx}`]
            );
            newState[moduleKey] = allSubChecked;
          });
        }
      });
  
      // Sync section checkbox: if all modules are checked → section is checked
      const allModulesChecked = groupedBySection[section].every((_, modIdx) =>
        !!newState[`module-${section}-${modIdx}`]
      );
      newState[sectionKey] = allModulesChecked;
    });
  
    return newState;
  };
  
  const handleCheckboxChange = (key, type, parentKey = null, crudType = null) => {
    
    if(checkedRoleName == ""){
      showSnackbar("Please Select the Role Name","error");
      return 
    }
    setCheckedItems(prev => {
      const newState = { ...prev };
      
      if (type === 'section-crud') {
        const parts = key.split('-');
        const section = parts[2];
        const actionType = parts[3];
      
        if (!groupedBySection[section]) return newState;
      
        newState[key] = !prev[key];
      
        groupedBySection[section].forEach((perm, permIdx) => {
          const moduleCrudKey = `module-crud-${section}-${permIdx}-${actionType}`;
          newState[moduleCrudKey] = newState[key];
      
          if (perm.sub_module) {
            perm.sub_module.forEach((sub, subIdx) => {
              const subCrudKey = `submodule-${section}-${permIdx}-${subIdx}-${actionType}`;
              newState[subCrudKey] = newState[key];
            });
          }
        });
      } else if (type === 'module-crud') {
        const parts = key.split('-');
        const section = parts[2];
        const permIdx = parts[3];
        const crudType = parts[4];
      
        newState[key] = !prev[key];
      
        const perm = groupedBySection[section][permIdx];
      
        // 1️⃣ Sync all submodule CRUDs based on module's new state
        if (perm.sub_module) {
          perm.sub_module.forEach((sub, subIdx) => {
            const subCrudKey = `submodule-${section}-${permIdx}-${subIdx}-${crudType}`;
            newState[subCrudKey] = newState[key];
          });
        }
        const allModuleCrudsChecked = groupedBySection[section].every((_, mIdx) =>
          !!newState[`module-crud-${section}-${mIdx}-${crudType}`]
        );
      
        newState[`section-crud-${section}-${crudType}`] = allModuleCrudsChecked;
      }
      
       else if (type === 'section') {
        const section = key.replace('section-', '');
        newState[key] = !prev[key];
      
        groupedBySection[section].forEach((perm, permIdx) => {
          const moduleKey = `module-${section}-${permIdx}`;
          newState[moduleKey] = newState[key];
      
          ['create', 'edit', 'delete'].forEach((crudType) => {
            const sectionCrudKey = `section-crud-${section}-${crudType}`;
            const moduleCrudKey = `module-crud-${section}-${permIdx}-${crudType}`;
      
            if (!newState[key]) {
              newState[sectionCrudKey] = false;
              newState[moduleCrudKey] = false;
            }
          });
      
          if (perm.sub_module) {
            perm.sub_module.forEach((sub, subIdx) => {
              const subKey = `submodule-${section}-${permIdx}-${subIdx}`;
              newState[subKey] = newState[key];
      
              ['create', 'edit', 'delete'].forEach((crudType) => {
                const subCrudKey = `submodule-${section}-${permIdx}-${subIdx}-${crudType}`;
                if (!newState[key]) {
                  newState[subCrudKey] = false;
                }
              });
            });
          }
        });
      }
       else if (type === 'module') {
        const parts = key.split('-');
        const section = parts[1];
        const permIdx = parts[2];
      
        newState[key] = !prev[key];
      
        const perm = groupedBySection[section][permIdx];
      
        // 1️⃣ Sync all submodules
        if (perm.sub_module) {
          perm.sub_module.forEach((sub, subIdx) => {
            const subKey = `submodule-${section}-${permIdx}-${subIdx}`;
            newState[subKey] = newState[key];
      
            // Also force submodule CRUDs to false if module is unchecked
            ['create', 'edit', 'delete'].forEach((crudType) => {
              const subCrudKey = `submodule-${section}-${permIdx}-${subIdx}-${crudType}`;
              if (!newState[key]) {
                newState[subCrudKey] = false;
              }
            });
          });
        }
      
        // 2️⃣ Also force module's own CRUDs to false if unchecked
        ['create', 'edit', 'delete'].forEach((crudType) => {
          const moduleCrudKey = `module-crud-${section}-${permIdx}-${crudType}`;
          if (!newState[key]) {
            newState[moduleCrudKey] = false;
          }
        });
      
        // 3️⃣ Sync section checkbox based on all modules
        const allModulesChecked = groupedBySection[section].every((_, idx) =>
          idx === Number(permIdx) ? newState[key] : !!prev[`module-${section}-${idx}`]
        );
      
        newState[`section-${section}`] = allModulesChecked;
      }else if (type === 'crud') {
        newState[key] = !prev[key];
      
        const [_, section, permIdx, subIdx, crudType] = key.split('-');
      
        const allSubCrudsChecked = groupedBySection[section][permIdx].sub_module.every((_, sIdx) =>
          sIdx === Number(subIdx)
            ? newState[`submodule-${section}-${permIdx}-${subIdx}-${crudType}`]
            : !!prev[`submodule-${section}-${permIdx}-${sIdx}-${crudType}`]
        );
      
        const moduleCrudKey = `module-crud-${section}-${permIdx}-${crudType}`;
        newState[moduleCrudKey] = allSubCrudsChecked;
      
        const allModuleCrudsChecked = groupedBySection[section].every((_, mIdx) =>
          mIdx === Number(permIdx)
            ? newState[`module-crud-${section}-${permIdx}-${crudType}`]
            : !!prev[`module-crud-${section}-${mIdx}-${crudType}`]
        );
      
        const sectionCrudKey = `section-crud-${section}-${crudType}`;
        newState[sectionCrudKey] = allModuleCrudsChecked;
      }
      else if (type === 'submodule') {
        newState[key] = !prev[key];
      
        ['create', 'edit', 'delete'].forEach((crudType) => {
          const subCrudKey = `${key}-${crudType}`;
          if (!newState[key]) {
            newState[subCrudKey] = false;
          }
        });
      
        const [_, section, permIdx, subIdx] = key.split('-');
        const allSubChecked = groupedBySection[section][permIdx].sub_module.every((_, idx) =>
          idx === Number(subIdx) ? newState[key] : !!prev[`submodule-${section}-${permIdx}-${idx}`]
        );
      
        newState[`module-${section}-${permIdx}`] = allSubChecked;
      
        const allModulesChecked = groupedBySection[section].every((_, modIdx) =>
          !!newState[`module-${section}-${modIdx}`]
        );
      
        newState[`section-${section}`] = allModulesChecked;
      };
      
      
      return enforceCheckboxRules(newState);
    });
  };
  const getModuleCrudActions = (section, permIdx) => {
    const crudStatus = { create: false, edit: false, delete: false };
    const perm = groupedBySection[section][permIdx];
    
    if (perm.action === 'Yes') {
      crudStatus.create = crudStatus.edit = crudStatus.delete = true;
    } else if (typeof perm.action === 'object') {
      Object.keys(perm.action).forEach(key => {
        if (perm.action[key] === true) {
          crudStatus[key] = true;
        }
      });
    }
    
    // Check submodules too
    if (perm.sub_module) {
      perm.sub_module.forEach(sub => {
        if (sub.action && typeof sub.action === 'object') {
          Object.keys(sub.action).forEach(key => {
            if (sub.action[key] === true) {
              crudStatus[key] = true;
            }
          });
        }
      });
    }
    
    return crudStatus;
  };
  const normalizePermissionSection = (section) => {
    if (section === "Generated Forms") return "Generated Form";
    return section;
  };

  const parseRolePermissions = (rawPermissions) => {
    let parsedPermissions = rawPermissions;
    if (typeof parsedPermissions === "string") {
      try {
        parsedPermissions = JSON.parse(parsedPermissions);
      } catch (e) {
        console.error("Invalid role permissions JSON", e);
        return [];
      }
    }
    if (!Array.isArray(parsedPermissions)) return [];
    if (typeof parsedPermissions[0] === "string") {
      try {
        parsedPermissions = JSON.parse(parsedPermissions[0]);
      } catch (e) {
        console.error("Invalid nested role permissions JSON", e);
        return [];
      }
    }
    if (!Array.isArray(parsedPermissions)) return [];

    return parsedPermissions.map((perm) => ({
      ...perm,
      section: normalizePermissionSection(perm.section),
      module: normalizePermissionSection(perm.module),
      sub_module: Array.isArray(perm.sub_module) ? perm.sub_module : [],
    }));
  };

  const buildCheckedItemsFromPermissions = (tabPermissions) => {
    const newCheckedItems = {};
    const selectedGrouped = (tabPermissions || []).reduce((acc, perm) => {
      const section = normalizePermissionSection(perm.section);
      if (!acc[section]) acc[section] = [];
      acc[section].push({ ...perm, section });
      return acc;
    }, {});

    Object.entries(groupedBySection).forEach(([section, uiModules]) => {
      const roleModules = selectedGrouped[section] || [];
      let sectionChecked = true;
      const sectionCrud = { create: true, edit: true, delete: true };

      if (roleModules.length === 0) {
        sectionChecked = false;
        uiModules.forEach((uiModule, uiIdx) => {
          const moduleKey = `module-${section}-${uiIdx}`;
          newCheckedItems[moduleKey] = false;
          ["create", "edit", "delete"].forEach((crud) => {
            newCheckedItems[`module-crud-${section}-${uiIdx}-${crud}`] = false;
          });
          const uiSubs = Array.isArray(uiModule.sub_module) ? uiModule.sub_module : [];
          uiSubs.forEach((_, subIdx) => {
            const subKey = `submodule-${section}-${uiIdx}-${subIdx}`;
            newCheckedItems[subKey] = false;
            ["create", "edit", "delete"].forEach((crud) => {
              newCheckedItems[`${subKey}-${crud}`] = false;
            });
          });
        });
        ["create", "edit", "delete"].forEach((crud) => {
          newCheckedItems[`section-crud-${section}-${crud}`] = false;
        });
        newCheckedItems[`section-${section}`] = false;
        return;
      }

      uiModules.forEach((uiModule, uiIdx) => {
        const roleModule = roleModules.find((rm) => rm.module === uiModule.module);
        const moduleKey = `module-${section}-${uiIdx}`;
        let moduleChecked = true;
        const moduleCrud = { create: true, edit: true, delete: true };
        const uiSubs = Array.isArray(uiModule.sub_module) ? uiModule.sub_module : [];
        const roleSubs = Array.isArray(roleModule?.sub_module) ? roleModule.sub_module : [];

        if (!roleModule) {
          moduleChecked = false;
          sectionChecked = false;
          Object.keys(moduleCrud).forEach((c) => {
            moduleCrud[c] = false;
          });
        } else if (uiSubs.length === 0) {
          // Leaf modules (Configuration, Generated Form, etc.)
          moduleChecked = true;
          ["create", "edit", "delete"].forEach((crud) => {
            const val =
              roleModule.action === "Yes" ||
              roleModule.action === "yes" ||
              roleModule.action?.[crud] === true;
            newCheckedItems[`module-crud-${section}-${uiIdx}-${crud}`] = val;
            moduleCrud[crud] = val;
            if (!val) sectionCrud[crud] = false;
          });
        } else {
          ["create", "edit", "delete"].forEach((crud) => {
            const val =
              roleModule.action === "Yes" ||
              roleModule.action === "yes" ||
              roleModule.action?.[crud] === true;
            newCheckedItems[`module-crud-${section}-${uiIdx}-${crud}`] = val;
            if (uiSubs.length !== roleSubs.length) {
              moduleCrud[crud] = false;
              sectionCrud[crud] = false;
            } else if (!val && roleSubs.length === 0) {
              moduleCrud[crud] = false;
              sectionCrud[crud] = false;
            }
          });

          uiSubs.forEach((uiSub, subIdx) => {
            const roleSub = roleSubs.find((rs) => rs.name === uiSub.name);
            const subKey = `submodule-${section}-${uiIdx}-${subIdx}`;
            let subChecked = true;

            if (!roleSub) {
              subChecked = false;
            } else {
              ["create", "edit", "delete"].forEach((crud) => {
                const val = roleSub.action?.[crud] === true;
                newCheckedItems[`${subKey}-${crud}`] = val;
                if (!val) {
                  moduleCrud[crud] = false;
                  sectionCrud[crud] = false;
                }
              });
            }

            newCheckedItems[subKey] = subChecked;
            if (!subChecked) {
              moduleChecked = false;
              sectionChecked = false;
            }
          });
        }

        newCheckedItems[moduleKey] = moduleChecked;
        if (!moduleChecked) sectionChecked = false;

        ["create", "edit", "delete"].forEach((crud) => {
          newCheckedItems[`module-crud-${section}-${uiIdx}-${crud}`] = moduleCrud[crud];
        });
      });

      ["create", "edit", "delete"].forEach((crud) => {
        newCheckedItems[`section-crud-${section}-${crud}`] = sectionCrud[crud];
      });
      newCheckedItems[`section-${section}`] = sectionChecked;
    });

    return newCheckedItems;
  };

  const hydrateRolePermissions = (rawPermissions) => {
    const parsedPermissions = parseRolePermissions(rawPermissions);
    let tabPermissions;
    if (activeTab === "Audit") {
      setPermissionAccessed(parsedPermissions.filter((p) => p.service === "Registers"));
      tabPermissions = parsedPermissions.filter((p) => p.service !== "Registers");
    } else {
      setPermissionAccessed(parsedPermissions.filter((p) => p.service === "Audit"));
      tabPermissions = parsedPermissions.filter((p) => p.service !== "Audit");
    }
    setBtnDataTag(tabPermissions.length > 0 ? "Update" : "Submit");
    setCheckedItems(buildCheckedItemsFromPermissions(tabPermissions));
  };

  const handleRoleChange = (e) => {
    const selectedRoleId = e.target.value;
    setCheckedRoleName(selectedRoleId);

    const selectedRole = roleData.find(
      (item) => item.id.toString() === selectedRoleId
    );

    if (!selectedRole?.permissions) {
      setCheckedItems({});
      setPermissionAccessed([]);
      setBtnDataTag("Submit");
      return;
    }

    hydrateRolePermissions(selectedRole.permissions);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const getRoleDetaildata = roleData.find((item) => item.id == checkedRoleName);
    if(!getRoleDetaildata){
      showSnackbar("Please Select the role","error");
      return 
    }
    
    const result = [];
    
    Object.entries(groupedBySection).forEach(([section, modules]) => {
      modules.forEach((module, permIdx) => {
        const moduleKey = `module-${section}-${permIdx}`;
        const moduleChecked = !!checkedItems[moduleKey];
        const subModules = [];
        module.sub_module?.forEach((sub, subIdx) => {
          const subKey = `submodule-${section}-${permIdx}-${subIdx}`;
          if (checkedItems[subKey]) {
            const subCrudAction = {
              create: !!checkedItems[`${subKey}-create`],
              edit: !!checkedItems[`${subKey}-edit`],
              delete: !!checkedItems[`${subKey}-delete`],
            };
            subModules.push({
              name: sub.name || sub.sub_module,
              action: subCrudAction,
            });
          }
        });
  
        // Determine module action for modules without submodules
        let moduleAction;
        if (!module.sub_module || module.sub_module.length === 0) {
          if (moduleChecked) {
            moduleAction = {
              create: !!checkedItems[`module-crud-${section}-${permIdx}-create`],
              edit: !!checkedItems[`module-crud-${section}-${permIdx}-edit`],
              delete: !!checkedItems[`module-crud-${section}-${permIdx}-delete`],
            };
          } else {
            return; // skip unchecked modules without submodules
          }
        } else {
          // For modules with submodules
          moduleAction = subModules.length > 0 ? "Yes" : "No";
        }
  
        result.push({
          service: module.service,
          section: normalizePermissionSection(module.section),
          module: normalizePermissionSection(module.module),
          action: moduleAction,
          sub_module: subModules,
        });
      });
    });
    const filteredResult = result.filter(item => {
      if (typeof item.action === 'string') {
        return item.action !== 'No';
      }
      return true;
    });
  
    const merged = [...filteredResult, ...permissionAccessed];
    
    try {
        const getRoleDetails = roleData.find((item) => item.id == checkedRoleName);
        const getPermittedData = {
            permissions:merged,
            role_name:getRoleDetails.role_name
        }
        if (btnDataTag === "Submit" && merged.length === 0){
          showSnackbar("Please Select the Permissions","warning");
          return;
        }
        const response = await dispatch(updateRoleById(getRoleDetails.id,getPermittedData));
        if(response.success === true){
            showSnackbar(response.message);
            
            if(merged.length > 0){
              setBtnDataTag("Update")
            }else{
              setBtnDataTag("Submit")
            }
            // Keep local role data in sync, then re-check the same role from saved permissions
            setRoleData((prev) =>
              prev.map((role) =>
                role.id == getRoleDetails.id
                  ? { ...role, permissions: merged }
                  : role
              )
            );
            hydrateRolePermissions(merged);
            handleFetchRoleData();
        }else{
            showSnackbar("Something went wrong","warning");
        }
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
  };      
  
  return (
    <div className="contaner-fluid">
      <div className="col-md-12 assignPermission-main-container">
        <div className="row assignPermission-main-header">
          <h5 className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Assign Permissions To Roles</h5>
        </div>
        <div className="row assignPermission-main-body">
          <div className="assignPermission-sub-header d-flex justify-content-between">
            <div className="title-header d-flex">
              <div className="logoicon">
                <img src={mainLogo} alt="" />
              </div>
              <h5>Assign Permissions</h5>
            </div>
            <div className="data-header">
              <div className="section-toggle-list d-flex gap-1">
                {Object.keys(groupedBySection).map((section, idx) => {
                  const sectionKey = `section-${section}`;
                  const isActive = expandedSections[sectionKey];

                  return (
                    <button
                      key={idx}
                      className={` ${isActive ? 'active-btn-permission' : ''}`}
                      onClick={() => toggleSection(sectionKey)}
                    >
                      {section}
                    </button>
                  );
                })}
              </div>
            </div>
              <div className="role-data d-flex">
                <label htmlFor=""> Role Name :</label>
                <select
                  id="emp_role"
                  name="emp_role"
                  className="form-select text-center"
                  onChange={handleRoleChange}
                  value={checkedRoleName}
                  required
                  >
                  <option value="">-- Select --</option>
                  {roleData?.map((item) => (
                      <option key={item.id} value={item.id}>
                      {item.role_name}
                      </option>
                  ))}
                </select>
              </div>
          </div>
          <div className="assignPermission-data-table table-responsive p-0 ">
            <table className='table'>
              <thead>
                <tr className='sticky-top-permision'>
                  <th><img src={section_header_icon} alt="" />Section / Module / Submodule</th>
                  <th><img src={create_header_icon} alt=""  />Create</th>
                  <th><img src={edit_header_icon} alt=""  />Edit</th>
                  <th><img src={delete_header_icon} alt=""  />Delete</th>
                </tr>
              </thead>
              
              <tbody>
                {Object.keys(groupedBySection).map((section, idx) => {
                  const sectionKey = `section-${section}`;
                  // const submoduleCount = groupedBySection[section].reduce(
                  //   (count, perm) => count + (perm.module?.length || 0),
                  //   0
                  // );
                  const moduleCount = groupedBySection[section]?.length || 0;
                  return (
                    <React.Fragment key={idx}>
                    {}
                      {/* Section Row */}
                      <tr className="section-row">
                        <td 
                          onClick={() => toggleSection(sectionKey)}
                        >
                          <div className='nameData  d-flex'>
                            <input 
                              type="checkbox" 
                              checked={checkedItems[sectionKey] || false}
                              onChange={() => handleCheckboxChange(sectionKey, 'section')}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <span>
                              {section}
                            </span>
                          </div>
                          <div className='countData d-flex'>
                            <div className="icondata">
                              
                            {expandedSections[sectionKey] ? <IoIosArrowDown /> : <IoIosArrowForward />}

                            </div>
                            <span 
                              className="badgedata"
                            >
                              {moduleCount}
                            </span>
                          </div>
                        </td>
                        {["create", "edit", "delete"].map((crudType) => {
                          const sectionCrudActions = getSectionCrudActions(section);

                          return (
                            <td key={crudType}>
                              {sectionCrudActions[crudType] &&
                                hasAnySectionAction(
                                  groupedBySection[section],
                                  crudType
                                ) && (
                                  <input
                                    type="checkbox"
                                    checked={
                                      checkedItems[
                                        `section-crud-${section}-${crudType}`
                                      ] || false
                                    }
                                    onChange={() =>
                                      handleCheckboxChange(
                                        `section-crud-${section}-${crudType}`,
                                        "section-crud"
                                      )
                                    }
                                    disabled={!checkedItems[`section-${section}`]}
                                  />
                                )}
                            </td>
                          );
                        })}
                      </tr>

                      {/* Modules */}
                      {expandedSections[sectionKey] &&
                        groupedBySection[section].map((perm, permIdx) => {
                          const moduleKey = `module-${section}-${permIdx}`;
                          const subCount = perm.sub_module?.length || 0;

                          return (
                            <React.Fragment key={moduleKey}>
                              {/* Module Row */}
                              <tr className="module-row">
                                <td>
                                <input 
                                  type="checkbox" 
                                  checked={checkedItems[moduleKey] || false}
                                  onChange={() => handleCheckboxChange(moduleKey, 'module')}
                                />
                                  <span>
                                    {perm.module}
                                  </span>
                                  {subCount > 0 && (
                                    <span className="badgemoduledata">
                                      {subCount}
                                    </span>
                                  )}
                                </td>

                                {/* Module-level CRUD checkboxes */}
                                {/* {['create', 'edit', 'delete'].map((crudType) => {
                                  const moduleCrudActions = getModuleCrudActions(section, permIdx);
                                  return (
                                    <td key={crudType}>
                                      {moduleCrudActions[crudType] && (
                                        <input
                                          type="checkbox"
                                          checked={checkedItems[`module-crud-${section}-${permIdx}-${crudType}`] || false}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              `module-crud-${section}-${permIdx}-${crudType}`,
                                              'module-crud'
                                            )
                                          }
                                          disabled={
                                            perm.sub_module?.length > 0
                                              ? !checkedItems[`module-${section}-${permIdx}`]
                                              : false
                                          }
                                        />
                                      )}
                                    </td>
                                  );
                                })} */}
                                {/* Module-level CRUD checkboxes */}
                                {/* {["create", "edit", "delete"].map((crudType) => {
                                  const moduleCrudActions = getModuleCrudActions(section, permIdx);

                                  return (
                                    <td key={crudType}>
                                      {moduleCrudActions[crudType] &&
                                        hasAnySubAction(perm.sub_module, crudType) && (
                                          <input
                                            type="checkbox"
                                            checked={
                                              checkedItems[
                                                `module-crud-${section}-${permIdx}-${crudType}`
                                              ] || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                `module-crud-${section}-${permIdx}-${crudType}`,
                                                "module-crud"
                                              )
                                            }
                                            disabled={
                                              !checkedItems[`module-${section}-${permIdx}`]
                                            }
                                          />
                                        )}
                                    </td>
                                  );
                                })} */}
{["create", "edit", "delete"].map((crudType) => {
  const moduleCrudActions = getModuleCrudActions(section, permIdx);

  return (
    <td key={crudType}>
      {moduleCrudActions[crudType] &&
        hasAnyModuleAction(perm, crudType) && (
          <input
            type="checkbox"
            checked={
              checkedItems[
                `module-crud-${section}-${permIdx}-${crudType}`
              ] || false
            }
            onChange={() =>
              handleCheckboxChange(
                `module-crud-${section}-${permIdx}-${crudType}`,
                "module-crud"
              )
            }
            disabled={
              !checkedItems[`module-${section}-${permIdx}`]
            }
          />
        )}
    </td>
  );
})}


                              </tr>

                              {/* Submodules */}
                              {perm.sub_module?.map((sub, subIdx) => {
                                const subKey = `submodule-${section}-${permIdx}-${subIdx}`;
                                
                                return (<tr className="submodule-row" key={subIdx}>
                                <td>
                                  <label className="custom-checkbox">
                                    <input 
                                      type="checkbox" 
                                      checked={checkedItems[subKey] || false}
                                      onChange={() => handleCheckboxChange(subKey, 'submodule', moduleKey)}
                                    />
                                  </label>
                                  <span>{sub.name}</span>
                                </td>
                                
                                {['create', 'edit', 'delete'].map((crudType) => (
                                  <td key={crudType}>
                                    {sub.action && isActionEnabled(sub.action, crudType) && (
                                      <label className="custom-checkbox">
                                        <input
                                          type="checkbox"
                                          checked={checkedItems[`${subKey}-${crudType}`] || false}
                                          onChange={() => handleCheckboxChange(`${subKey}-${crudType}`, 'crud')}
                                          disabled={!checkedItems[`submodule-${section}-${permIdx}-${subIdx}`]}
                                        />
                                        {/* <span className="checkmark"></span> */}
                                      </label>
                                    )}
                                  </td>
                                ))}
                              </tr>
                              
                                );
                              })}
                            </React.Fragment>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col-md-12">
          <button className="btn btn-sm btn-success mx-2 my-3"  onClick={handleSubmit}>{btnDataTag}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignPermission